import { Dropdown } from "react-bootstrap";
import MyModal from "../../../Common/my-modal/my-modal.component";
import "./index.styles.scss";
import SearchIcon from "../../../icons/search.icon";
import { useEffect, useMemo, useRef, useState } from "react";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import { useAuth } from "../../../context/Auth";
import { getAPIData, postData } from "../../../../Utils/commonApi";
import ImageLoader from "../../../Common/ImageLoader";
import ImageWithInitials from "../../../../Utils/ImageWithInitials";

const mockClients = [
  {
    MSPId: 15459160,
    MSPLogo: "https://placehold.co/40x40/grey/white",
    MSPName: "John Doe",
    address: 'Scotland',
    email: 'john.doe@gmail.com',
  },
  {
    MSPId: 2,
    MSPLogo: "https://placehold.co/40x40/grey/white",
    MSPName: "Dan Brown",
    address: 'Scotland',
    email: 'dan.brown@gmail.com',
  },

  {
    MSPId: 3,
    MSPLogo: "https://placehold.co/40x40/grey/white",
    MSPName: "Jane Doe",
    address: 'Scotland',
    email: 'jane.doe@gmail.com',
  },
];

const ClientSelector = ({ clients, selected, getClients = () => { }, onSelect }) => {
  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const filteredClients = useMemo(() => {
    return clients.filter((client) => client.MSPName.toLowerCase().includes(searchValue.toLowerCase()));
  }, [clients, searchValue]);

  const handleSelect = (client) => {
    onSelect(client);
    setIsOpen(false);
    setSearchValue('');
  }

  return (
    <Dropdown
      className="client-selector transparennt-wrapper-dropdown my-dropdown my-dropdown-common w-100"
      onToggle={(isOpen) => {
        setIsOpen(isOpen);
        if (isOpen) {
          inputRef.current?.focus();
        }
      }}
      show={isOpen && filteredClients.length > 0}
    >
      <Dropdown.Toggle className="w-100">
        <div className="client-input w-100">
          <input
            type="text"
            placeholder="Search for a client"
            className="f-14 line-height-22 f-grey f-400 f-black"
            value={selected?.MSPName ?? searchValue}
            onChange={(e) => {
              if (selected) {
                onSelect(null);
                return;
              }
              setSearchValue(e.target.value)
              getClients(e.target.value);
              setIsOpen(true);
            }}
            ref={inputRef}
            autoFocus
          />
          <div className="search-icon">
            <SearchIcon width={16} height={16} />
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="menu client-dropdown-menu" popperConfig={{ strategy: 'fixed' }} renderOnMount>
        {filteredClients.map((client) => (
          <div key={client.MSPId} className="client-item item" onClick={() => handleSelect(client)}>
            <ImageLoader
              src={client.MSPLogo}
              alt={client.MSPName}
              className="client-icon"
              width={24}
              height={24}
              noImageComponent={(
                <div className="client-icon">
                  <ImageWithInitials
                    initials={client?.MSPName?.slice(0, 2)}
                    width={24}
                    height={24}
                    borderRadius={2}
                    background={"purple"}
                  />
                </div>
              )}
            />
            <div className="client-info">
              <h3 className="f-14 line-height-22 f-black f-500">{client.MSPName}</h3>
            </div>
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const SelectClientModal = ({ show, onCancel = () => { }, onContinue = () => { } }) => {
  const { authTokens } = useAuth();
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    if (show) {
      getClients();
    }
  }, [show])

  async function getClients(searchStr) {
    return new Promise((resolve, reject) => {
      getAPIData(18, authTokens, {
        optionStrEnum1: searchStr ?? '',
      })
        .then((response) => {
          if (response?.mr?.Success) {
            setClients(response?.SecurityStackReport_List)
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        })
        .catch((error) => {
          reject(error);
          CallToast("Something went wrong", false, false, "v2style");
        });
    });
  }


  return (
    <MyModal show={show} className="select-client-modal">
      <MyModal.Body className="d-flex flex-column gap-16">
        <div className="client-modal-title f-black text-center">Security Stack Report</div>
        <p className="m-0 f-14 line-height-22 f-black text-center">Please first select the client you are going to build the report for:</p>
        <div className="d-flex flex-column gap-4 w-100">
          <h3 className="m-0 f-12 line-height-18 f-grey f-500">Client Name</h3>
          <ClientSelector clients={clients} selected={selectedClient} getClients={getClients} onSelect={setSelectedClient} />
        </div>
        {selectedClient && (
          <div className="selected-client-card">
            <div className="client-icon-wrapper">
              <ImageLoader
                src={selectedClient.MSPLogo}
                alt={selectedClient.MSPName}
                className=""
                noImageComponent={(
                  <div className="">
                    <ImageWithInitials
                      initials={selectedClient?.MSPName?.slice(0, 2)}
                      width={80}
                      height={80}
                      borderRadius={2}
                      background={"purple"}
                    />
                  </div>
                )}
              />
            </div>
            <div className="client-info">
              <h3 className="f-14 line-height-22 f-black f-400 m-0">{selectedClient.MSPName}</h3>
              {/* <p className="m-0 f-12 line-height-18 f-grey f-400">{selectedClient.address}</p> */}
              {/* <p className="m-0 f-12 line-height-18 f-grey f-400">{selectedClient.email}</p> */}
            </div>
          </div>
        )}
      </MyModal.Body>
      <MyModal.Footer className="gap-8">
        <MyModal.CancelButton onClick={onCancel}>
          Cancel
        </MyModal.CancelButton>
        <MyModal.ApplyButton onClick={() => {
          onContinue(selectedClient);
          // createSecurityStackReport(15546999, 'gdfdfhdfh')
        }}>
          Continue
        </MyModal.ApplyButton>
      </MyModal.Footer>
    </MyModal>
  );
};

export default SelectClientModal;
